import { useState, useEffect, useContext } from 'react'
import DashboardLayout from 'components/layout/dashboard/DashboardLayout'
import { useTranslation } from 'react-i18next';
import './payouts.css'
import './components/payoutItem/payoutItem.css';
import Modal from 'components/modal/Modal';
import Tableau from 'components/DataComponents/Tableau/Tableau';
import FilterComponent from 'components/Filters/FilterComponent/FilterComponent';
import PageLoader from 'components/pageLoader/PageLoader';
import { formatDate } from 'utils/date';
import useFilters from 'hooks/useFilters';
import Notification from 'components/notifications/Notification';
import { launchError, launchSuccess } from 'components/notifications';
import { formatIBAN } from 'utils/iban';
import { approvePayout, fetchPendingPayouts } from 'services/payoutServices';
import AuthContext from 'contexte/AuthContext';

const Payouts = () => {

  const { t } = useTranslation()
  const { user } = useContext(AuthContext)

  const initialFilters = {
    fetchLimit: 10,
    page: 0,
    search: ''
  };

  const { filters, handleFiltersChange, resetFilters } = useFilters(initialFilters);

  const setFetchLimit = (newLimit) => handleFiltersChange('fetchLimit', newLimit);
  const setPage = (newPage) => handleFiltersChange('page', newPage);
  let searchTimeout
  const setSearch = (newSearch) => {
    clearTimeout(searchTimeout)
    searchTimeout = setTimeout(() => {
      handleFiltersChange('search', newSearch);
      handleFiltersChange('page', 0);
    }, 300)
  }


  const [loading, setLoading] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [modalIndex, setModalIndex] = useState(1)
  const [pendingPayouts, setPendingPayouts] = useState([]);

  useEffect(() => {

    const fetchData = async () => {
      const payouts = await fetchPendingPayouts({
        compact: 0,
        user,
        page: filters.page,
        limit: filters.fetchLimit,
        search: filters.search
      });
      setPendingPayouts(payouts?.map(item => ({ ...item, payment_provider_additional_fields: JSON.parse(item.payment_provider_additional_fields) })));
    }
    try {
      setLoading(true);
      fetchData();
    } catch (e) {
      launchError(t('notifications.payouts.pendingPayouts.fetch.error'));
    } finally {
      setLoading(false);
    }

  }, [user, t, filters.page, filters.fetchLimit, filters.search])

  const onClickFunction = (index) => {
    setModalIndex(index)
    setIsModalOpen(true);
  }

  const transformDatatoTbody = (data) => {
    return data.map(item => {
      return {
        data: [
          formatDate({ date: item.created_at, time: true }),
          item.payment_provider_additional_fields.bank_account_holders_name,
          formatIBAN(item.payment_provider_additional_fields.bank_iban),
          item.amount
        ]
      }
    })
  }


  const approve = async () => {
    try {
      const selectedRow = pendingPayouts[modalIndex];
      const { bank_iban: iban, bank_name } = selectedRow.payment_provider_additional_fields
      await approvePayout({ user, iban, bank_name, amount: selectedRow.amount, ago_uuid: selectedRow.customer_id, ago_withdraw_id: selectedRow.id })
      launchSuccess(t(`notifications.payouts.pendingPayouts.approve.success`));
      setIsModalOpen(false);
      setModalIndex(-1);
    } catch (e) {
      launchError(t(`notifications.payouts.pendingPayouts.approve.error`));
      console.error(e)
    }
  }

  if (loading) return (
    <div className='pageLoaderBox'>
      <PageLoader />
    </div>
  )

  return (
    <DashboardLayout page={t("pages_name.payouts")}>
      <div>
        <Notification />
        <div>
          <div className='payouts_titleComponent'>
            <h2>{t('pages.payouts.title')}</h2>
          </div>
          <FilterComponent
            resetFilter={resetFilters}
            limit={true}
            fetchLimit={filters.fetchLimit}
            setFetchLimit={setFetchLimit}
            withSearch
            search={filters.search}
            setSearch={setSearch}
            searchPlaceHolder={'Entrez le nom ou prénom'}
          />
          <div className="table-container">
            <div className="table-column">
              <Tableau
                thead={[t("pages.payouts.date"), t("pages.payouts.reference"), t("pages.payouts.iban"), t("pages.payouts.amount")]}
                tbody={transformDatatoTbody(pendingPayouts)}
                hadModal={true}
                hadLink={false}
                onClickFunction={onClickFunction}
                page={filters.page} setPage={setPage}
                pagination={true}
                limit={filters.fetchLimit}
              />
            </div>
          </div>

          {
            isModalOpen && (
              <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} closeButton={false} >
                <h2 className='modal_title'>{t("pages.payouts.modal.title")}</h2>
                <div className="payout-details">
                  {
                    pendingPayouts[modalIndex].isDeleted === 1 && (
                      <div className='warning_deleted'>
                        <img src="https://assets-global.website-files.com/612cdb668b06dbb2a51f99ee/651e6e6668d310d564622c79_warning_img.png" alt="" width={25} />
                        <span>{t("pages.payouts.modal.user_deleted")}</span>
                      </div>
                    )
                  }
                  <p><strong>{t("pages.payouts.modal.name")}</strong> {pendingPayouts[modalIndex].payment_provider_additional_fields.bank_account_holders_name}</p>
                  <p><strong>{t("pages.payouts.modal.adress")}</strong> {pendingPayouts[modalIndex].complete_address || pendingPayouts[modalIndex].payment_provider_additional_fields.bank_account_holders_address}</p>
                  <p><strong>{t("pages.payouts.modal.birthday")}</strong> {new Date(pendingPayouts[modalIndex].birthDate).toLocaleDateString()}</p>
                  <p><strong>{t("pages.payouts.modal.bankName")}</strong> {pendingPayouts[modalIndex].payment_provider_additional_fields?.bank_name || 'N/A'}</p>
                  <p><strong>{t("pages.payouts.modal.iban")}</strong> {formatIBAN(pendingPayouts[modalIndex].payment_provider_additional_fields?.bank_iban) || 'N/A'}</p>
                </div>
                <hr className='modal_hr_button' />
                <div className='modal-button-div'>
                  <button className='close' onClick={() => setIsModalOpen(false)}>{t("pages.payouts.buttons.close")}</button>
                  <button className='valider' onClick={() => approve()}>{t("pages.payouts.buttons.accept")}</button>
                  <button className='refuser' onClick={() => { }}>{t("pages.payouts.buttons.refuse")}</button>
                </div>
              </Modal>
            )
          }
        </div>
      </div>
    </DashboardLayout>
  )
}

export default Payouts

